import _defineProperty from "/codebuild/output/src145264479/src/LandingPage/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { createStyles, getSortedBreakpoints, getSize, getBreakpointValue, rem } from '@mantine/core';
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var useStyles = createStyles(function (theme, _ref) {
  var size = _ref.size,
    gap = _ref.gap,
    orientation = _ref.orientation,
    includeGapInSize = _ref.includeGapInSize,
    _ref$breakpoints = _ref.breakpoints,
    breakpoints = _ref$breakpoints === void 0 ? [] : _ref$breakpoints;
  var getSlideStyles = function getSlideStyles(slideGap, slideSize) {
    var slideGapValue = getSize({
      size: slideGap,
      sizes: theme.spacing
    });
    var flexBasisValue = rem(slideSize);
    var marginStyles = includeGapInSize ? _defineProperty({}, orientation === "horizontal" ? "paddingRight" : "paddingBottom", slideGapValue) : _defineProperty({}, orientation === "horizontal" ? "marginRight" : "marginBottom", slideGapValue);
    return __spreadValues({
      flex: "0 0 ".concat(flexBasisValue)
    }, marginStyles);
  };
  var hasDiff = breakpoints.some(function (v) {
    return typeof v.slideGap !== "undefined" || typeof v.slideSize !== "undefined";
  });
  var slideBreakpoints = !hasDiff ? null : getSortedBreakpoints(theme, breakpoints).reduce(function (acc, breakpoint) {
    var property = "maxWidth" in breakpoint ? "max-width" : "min-width";
    var breakpointSize = getSize({
      size: property === "max-width" ? breakpoint.maxWidth : breakpoint.minWidth,
      sizes: theme.breakpoints
    });
    var breakpointGap = typeof breakpoint.slideGap === "undefined" ? gap : breakpoint.slideGap;
    var breakpointValue = getBreakpointValue(breakpointSize) - (property === "max-width" ? 1 : 0);
    acc["@media (".concat(property, ": ").concat(rem(breakpointValue), ")")] = getSlideStyles(breakpointGap, breakpoint.slideSize);
    return acc;
  }, {});
  return {
    slide: __spreadValues(__spreadValues({
      position: "relative"
    }, getSlideStyles(gap, size)), slideBreakpoints)
  };
});
export default useStyles;